import { render, staticRenderFns } from "./livingTipsDialog.vue?vue&type=template&id=200ae4a7&scoped=true"
import script from "./livingTipsDialog.vue?vue&type=script&lang=js"
export * from "./livingTipsDialog.vue?vue&type=script&lang=js"
import style0 from "./livingTipsDialog.vue?vue&type=style&index=0&id=200ae4a7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200ae4a7",
  null
  
)

export default component.exports